// import 'react-app-polyfill/ie11';
import FIREBASE from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/messaging';
// import 'firebase/analytics';
import firebaseConfig from './firebaseConfig';

export const firebase = FIREBASE;
export const firebaseApp = firebase.initializeApp(firebaseConfig);
export const firebaseAppAuth = firebaseApp.auth();
export const firebaseDb = firebaseApp.database();

/* -------------------------------------------------
   messaging: ritorna null su Safari / WebKit
   ------------------------------------------------- */
let cachedMessaging: firebase.messaging.Messaging | null | undefined;

export async function getMessaging() {
  if (cachedMessaging !== undefined) return cachedMessaging;

  const supported = await FIREBASE.messaging.isSupported();
  cachedMessaging = supported ? FIREBASE.app().messaging() : null;
  return cachedMessaging;
}

// export const firebaseMessaging = firebaseApp.messaging();
// export const firebaseAnalytics = firebase.analytics();

export const providers = {
  googleProvider: new firebase.auth.GoogleAuthProvider(),
  emailProvider: new firebase.auth.EmailAuthProvider(),
};

export function useFirebasePersistence() {
  // Rememeber me is true
  const setLocalPersistence = () =>
    firebaseAppAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

  // Rememeber me is false
  const setSessionPersistence = () =>
    firebaseAppAuth.setPersistence(firebase.auth.Auth.Persistence.SESSION);

  return {
    persistence: {
      setLocalPersistence,
      setSessionPersistence,
    },
  };
}
